module.exports = __webpack_public_path__ + "static/media/youtube.66c4feb6.svg";